import { Card, Space, theme, Typography } from 'antd'

const { Text } = Typography

export type GraphType = 'bar' | 'funnel' | 'radar'

interface CustomTooltipProps {
  type: GraphType
  active?: boolean
  payload?: readonly any[]
  defaultLabel?: string | number
  valueFormatter?: (value: number | undefined) => string
  customLabelFormatter?: (payload: any) => React.ReactNode
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({
  type,
  active,
  payload,
  defaultLabel,
  valueFormatter,
  customLabelFormatter,
}) => {
  const { token } = theme.useToken()

  const isVisible = active && payload && payload.length > 0

  const renderLabel = () => {
    if (customLabelFormatter && payload && payload.length > 0) {
      return customLabelFormatter(payload[0].payload)
    }
    return defaultLabel
  }

  if (!isVisible) return null

  if (type === 'bar') {
    return (
      <Card styles={{ body: { padding: 8, paddingTop: 5, paddingBottom: 5 } }}>
        <Space orientation="vertical" size={0}>
          <Text style={{ fontWeight: 500 }}>{renderLabel()}</Text>
          <Text style={{ color: token.colorPrimary }}>
            {valueFormatter
              ? valueFormatter(payload[0].value)
              : payload[0].value}
          </Text>
        </Space>
      </Card>
    )
  }

  if (type === 'funnel') {
    return (
      <Card styles={{ body: { padding: 8, paddingTop: 5, paddingBottom: 5 } }}>
        <Text>
          {payload[0].payload.name}:{' '}
          {valueFormatter ? valueFormatter(payload[0].value) : payload[0].value}
        </Text>
      </Card>
    )
  }

  if (type === 'radar') {
    return (
      <Card styles={{ body: { padding: 8, paddingTop: 5, paddingBottom: 5 } }}>
        <Space orientation="vertical" size={0}>
          <Text style={{ fontWeight: 500 }}>{renderLabel()}</Text>
          <Text style={{ color: token.colorPrimary }}>
            {valueFormatter
              ? valueFormatter(payload[0].value)
              : payload[0].value}
          </Text>
        </Space>
      </Card>
    )
  }

  return null
}

export default CustomTooltip
